import { FunctionComponent, useState } from 'react'
import { Box, TextField, Typography } from '@material-ui/core'
//@ts-ignore
import { useTheme } from 'styled-components'
import validator from 'validator'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { Button } from 'common/atoms/Button/Button'

interface ResetPasswordProps {
  onSubmit: Function
  setSelectedPage: Function
}

export const ResetPassword: FunctionComponent<ResetPasswordProps> = ({ onSubmit, setSelectedPage }) => {
  const theme = useTheme()
  const [email, setEmail] = useState('')
  const [emailValid, setEmailValid] = useState(false)
  const { logEventAnalytics } = useAnalytics()
  const { isDevice } = useScreenSizes()

  const onUsernameChange = (e: any) => {
    const value = e.target.value
    setEmail(value)
    const test = validator.isEmail(value)
    setEmailValid(test)
  }

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      margin="0em 0 6em 0"
    >
      <Typography variant="h5">
        <Box padding="0 0 0.3em 0" color={theme.colors.accent1}>
          <b>Recover Your Password</b>
        </Box>
      </Typography>
      <Box width= {isDevice ? '100%' : '30em'}>
      <Typography component="h4">
        <Box
          color={theme.colors.accent1}
        >
          Enter your email below and we will send you an email with a link to reset your password.
        </Box>
      </Typography>
      </Box>
      <Box width={isDevice ? '100%' : '30em'} marginTop='1em'>
        <TextField
          onChange={onUsernameChange}
          placeholder="Email"
          variant="outlined"
          size="small"
          fullWidth
        ></TextField>
      </Box>
      {!emailValid && email && (
        <Typography variant="body1">
          <Box color={theme.colors.error}>Email is Invalid</Box>
        </Typography>
      )}
      <Box display="flex" width={isDevice ? '100%' : '30em'} justifyContent="space-between" alignItems='center' paddingTop="1em" gridGap="1em">
        <Box>
        {/* @ts-ignore */}
        <Button
          design='primary'
          onClick={() => {
            setSelectedPage(0)
          }}
          fullWidth
          size={isDevice? "small" : "medium"}
        >
          <Box fontSize="0.8em">BACK</Box>
        </Button>
        </Box>
        <Box>
        {/* @ts-ignore */}
       <Button
          design='primary'
          onClick={() => {
            onSubmit(email?.toLowerCase())
            logEventAnalytics('User', 'Password reset', 'mixpanel', 'Password reset', { Email: email })
            setEmail('')
            setSelectedPage(0)
          }}
          disabled={!emailValid}
          fullWidth
          size={isDevice? "small" : "medium"}
          >
          <Box fontSize="0.8em">{isDevice ? 'SEND EMAIL' : 'SEND EMAIL'}</Box>
        </Button>
        </Box>
      </Box>
    </Box>
  )
}
